import { render, staticRenderFns } from "./FlatDetail.vue?vue&type=template&id=e47b7526&scoped=true"
import script from "./FlatDetail.vue?vue&type=script&lang=js"
export * from "./FlatDetail.vue?vue&type=script&lang=js"
import style0 from "./FlatDetail.vue?vue&type=style&index=0&id=e47b7526&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47b7526",
  null
  
)

export default component.exports